import { render, staticRenderFns } from "./GroupWeigh.vue?vue&type=template&id=c801291c&scoped=true"
import script from "./GroupWeigh.vue?vue&type=script&lang=ts"
export * from "./GroupWeigh.vue?vue&type=script&lang=ts"
import style0 from "./GroupWeigh.vue?vue&type=style&index=0&id=c801291c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c801291c",
  null
  
)

export default component.exports